import {
    type FragmentType,
    getFragmentData,
    graphql
} from '~/resources/graphql'
import { computed, ref } from 'vue'
import { useHead } from 'unhead'
import type { Script } from '@unhead/schema'

export const UseAnalyticsScriptOrganizationFragment = graphql(`
    fragment UseAnalyticsScriptOrganizationFragment on Organization {
        googleAnalyticsTag
        globalMarketingCode
    }
`)

const organizationFragment =
    ref<FragmentType<typeof UseAnalyticsScriptOrganizationFragment>>()

export function provideAnalyticsOrganizationFragment(
    organization: FragmentType<typeof UseAnalyticsScriptOrganizationFragment>
) {
    organizationFragment.value = organization
}

export function useAnalyticsScript() {
    const organizationData = computed(() =>
        getFragmentData(
            UseAnalyticsScriptOrganizationFragment,
            organizationFragment.value
        )
    )

    useHead({
        script: () => {
            const tags: Script[] = []

            if (
                organizationData.value !== undefined &&
                organizationData.value.googleAnalyticsTag !== ''
            ) {
                tags.push({
                    src: `https://www.googletagmanager.com/gtag/js?id=${organizationData.value.googleAnalyticsTag}`,
                    async: true
                })

                tags.push({
                    innerHTML: `window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new Date()); gtag('config', '${organizationData.value.googleAnalyticsTag}');`
                })
            }

            if (
                organizationData.value !== undefined &&
                organizationData.value.globalMarketingCode !== ''
            ) {
                tags.push({
                    innerHTML: organizationData.value.globalMarketingCode
                })
            }

            return tags
        }
    })
}
